import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserGraduate } from "@fortawesome/free-solid-svg-icons";
import { useSection } from "../data/content";
import "./StaffDetails.css";

export const staffDefault = [
  { sno: 1, facultyName: "Mr. Justin", designation: "Principal", qualification: "Bsc. Nursing" },
  { sno: 2, facultyName: "Ms. Priyanka Devi", designation: "Vice-Principal", qualification: "Bsc. Nursing" },
  { sno: 3, facultyName: "Mr. Deepak Masih", designation: "Tutor", qualification: "Msc. Nursing (Medical Surgical Nursing)" },
  { sno: 4, facultyName: "Mr. Rohan Kumar", designation: "Tutor", qualification: "Bsc. Nursing" },
  { sno: 5, facultyName: "Ms. Geeta Devi", designation: "Tutor", qualification: "Bsc. Nursing" },
  { sno: 6, facultyName: "Ms. Tejinder Kaur", designation: "Tutor", qualification: "Bsc. Nursing" },
  { sno: 7, facultyName: "Mr. Parminder Singh", designation: "Tutor", qualification: "Bsc. Nursing" },
  { sno: 8, facultyName: "Mr. Sukhjeet Singh", designation: "Tutor", qualification: "Bsc. Nursing" },
  { sno: 9, facultyName: "Ms. Satwinder Kaur", designation: "Tutor", qualification: "Bsc. Nursing" },
  { sno: 10, facultyName: "Mr. Sahil", designation: "Tutor", qualification: "Bsc. Nursing" },
  { sno: 11, facultyName: "Mr. Boota Singh", designation: "Tutor", qualification: "Bsc. Nursing" },
  { sno: 12, facultyName: "Mr. Ekant", designation: "Tutor", qualification: "Bsc. Nursing" },
  { sno: 13, facultyName: "Ms. Priya", designation: "Tutor", qualification: "Bsc. Nursing" },
  { sno: 14, facultyName: "Mr. Prabhjeet Singh", designation: "Tutor", qualification: "Bsc. Nursing" },
  { sno: 15, facultyName: "Ms. Ramandeep Kaur", designation: "Tutor", qualification: "Bsc. Nursing" },
  { sno: 16, facultyName: "Ms. Sharon", designation: "Tutor", qualification: "Bsc. Nursing" },
  { sno: 17, facultyName: "Mr. Firoz Ali", designation: "Tutor", qualification: "Bsc. Nursing" },
  { sno: 18, facultyName: "Ms. Kusum Lata", designation: "Tutor", qualification: "Bsc. Nursing" },
  { sno: 19, facultyName: "Mrs. Harsumeet Kaur", designation: "Tutor", qualification: "Bsc. Nursing" },
  { sno: 20, facultyName: "Ms. Payal", designation: "Tutor", qualification: "Bsc. Nursing" },
  { sno: 21, facultyName: "Mrs. Sneha Rani", designation: "Tutor", qualification: "Bsc. Nursing" },
];

const initials = (name) =>
  name
    .replace(/^(Mr|Mrs|Ms|Dr)\.?\s+/i, "")
    .split(" ")
    .map((w) => w[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

const StaffDetails = () => {
  const data = useSection("staff", staffDefault);
  const isLead = (role) => role === "Principal" || role === "Vice-Principal";

  return (
    <>
      <section className="page-hero">
        <span className="blob" aria-hidden="true" />
        <div className="container page-hero-inner">
          <span className="page-hero-icon">
            <FontAwesomeIcon icon={faUserGraduate} />
          </span>
          <p className="eyebrow">The people behind your learning</p>
          <h1 className="page-hero-title">College Staff &amp; Faculty</h1>
          <p className="page-hero-lead">
            Meet the {data.length} educators and mentors of the Medical Block at
            Sri Guru Arjun Dev Ji Group of Institutes, who guide every student
            from classroom to ward.
          </p>
        </div>
      </section>

      <section className="staff">
        <div className="container">
          <div className="staff-table" role="table">
            <div className="staff-row staff-row--head" role="row">
              <span>#</span>
              <span>Faculty</span>
              <span>Designation</span>
              <span>Qualification &amp; speciality</span>
            </div>
            {data.map((item) => (
              <div className="staff-row" role="row" key={item.sno}>
                <span className="staff-sno">{String(item.sno).padStart(2, "0")}</span>
                <span className="staff-name">
                  <span className={`staff-avatar ${isLead(item.designation) ? "is-lead" : ""}`}>
                    {initials(item.facultyName)}
                  </span>
                  {item.facultyName}
                </span>
                <span>
                  <span className={`staff-role ${isLead(item.designation) ? "is-lead" : ""}`}>
                    {item.designation}
                  </span>
                </span>
                <span className="staff-qual">{item.qualification}</span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default StaffDetails;
